const stripTrailingSlash = (s: string) => s.replace(/\/$/, "");

/**
 * Normalize `http://localhost:8080` → `http://127.0.0.1:8080` so requests
 * hit the same interface PHP `spark serve` usually binds.
 */
export function normalizeApiOrigin(raw: string): string {
  let u = stripTrailingSlash(raw.trim());
  u = u.replace(/^http:\/\/localhost\b/i, "http://127.0.0.1");
  u = u.replace(/^https:\/\/localhost\b/i, "https://127.0.0.1");

  return u;
}

const rawPublic = (import.meta.env.VITE_PUBLIC_API_URL || "").trim();

function isLocalBackendUrl(u: string): boolean {
  try {
    const url = new URL(u.includes("://") ? u : `https://${u}`);

    return url.hostname === "localhost" || url.hostname === "127.0.0.1";
  } catch {
    return false;
  }
}

/**
 * Dev + local/empty API URL → axios uses relative `/api` (Vite proxy).
 * Dev + remote URL or any production build with `VITE_PUBLIC_API_URL` → full origin + optional path (e.g. `/invoice`).
 */
const useRelativeApiInBrowser =
  import.meta.env.DEV && (!rawPublic || isLocalBackendUrl(normalizeApiOrigin(rawPublic)));

/** Absolute CI4 base (origin + optional subpath). */
export const serverApiOrigin = normalizeApiOrigin(
  (import.meta.env.VITE_INTERNAL_API_ORIGIN || rawPublic || "http://127.0.0.1:8080") as string,
);

/**
 * Axios baseURL: "" for same-origin / Vite dev proxy; else full public API root (supports subpath deploy).
 */
export const apiBaseURL = useRelativeApiInBrowser
  ? ""
  : rawPublic
    ? stripTrailingSlash(normalizeApiOrigin(rawPublic))
    : "";
